import React, { useState } from "react";
import './navbar.css';
import Logo from './../../assets/logo.svg';
import Anima from './../../assets/animation.png';
import Icon from './../../assets/etheware-icon.png';
import { RiMenuFill, RiCloseLine, RiAccountBoxFill } from 'react-icons/ri';
import { Image } from "react-bootstrap";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [accountMenu, setAccountMenu] = useState(false);

  const Menu = () => (
    <div className="nav-menu__container">

      <nav>
        <p><a href="https://espace.etheware.com/">Etheware Space</a></p>
        <p><a href="https://espace.etheware.com/supported-locations">Next Gen</a></p>
        <p><a href="https://espace.etheware.com/satellite-internet">Satellite Internet</a></p>
        <p><a href="/open-access-program">Open Access Program</a></p>
        <p><a href="/company">Company</a></p>
        <p><a href="/socials">Connect</a></p>
        <p><a href="/contact">Support</a></p>
      </nav>
    </div>
  );

  const AccountMenu = () => (
    <div className="account-menu__container">
      <Image className="space-photo" src={Anima} />
      <p><a href="/socials">Connect With Us</a></p>
      <p><a href="https://espace.etheware.com/">Etheware Space</a></p>
      <Image src={Logo} />
    </div>
  );

  return (
    <div className="navbar">
      <div className="navbar__logo">
        <a href="/"><img src={Logo} alt="Etheware Logo" /></a>
      </div>

      <div className="navbar__icon">
        <a href="/"><img src={Icon} alt="Etheware Icon" /></a>
      </div>

      <div className="navbar__links">
        <div className="nav__container">
          <p><a href="https://espace.etheware.com/">Etheware Space</a></p>
          <p><a href="https://espace.etheware.com/supported-locations">Next Gen</a></p>
           <p><a href="https://espace.etheware.com/satellite-internet">Satellite Internet</a></p>
          <p><a href="/open-access-program">Open Access Program</a></p>
          <p><a href="/company">Company</a></p>
          <p><a href="/socials">Connect</a></p>
          <p><a href="/contact">Support</a></p>
        </div>
      </div>

      <div className="navbar__menu">
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenuFill color="#fff" size={27} onClick={() => setToggleMenu(true)} />
        }
        {toggleMenu && <Menu />}
      </div>

      <div className="account__menu">
        {accountMenu
          ? <RiCloseLine color="#fff" size={20} onClick={() => setAccountMenu(false)} />
          : <RiAccountBoxFill color="#fff" size={20} onClick={() => setAccountMenu(true)} />
        }
        {accountMenu && <AccountMenu />}
      </div>
    </div>
  );
};

export default Navbar;
